<template>
	<div class="profile-wrapper">
		<div class="title">消息通知</div>
		<div class="tips">当自己发的帖子被评论、评论的内容被回复时，会收到邮件通知</div>
		<div class="change-email">
		  <div class="labelname">绑定通知邮箱</div>
		  <div>
			  <el-input v-model="data.email" size="medium" disabled placeholder="请输入内容"></el-input>
			  <el-button type="info"  @click="emailVisible = true">更换邮箱</el-button>
		  </div>  
		</div>
		<el-dialog title="绑定邮箱" width="30%" :visible.sync="emailVisible">
		  <el-form :model="form"  ref="form" :rules="rules">
		    <el-form-item prop="email">
		        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
		    </el-form-item>
		    <el-form-item prop="code">
		        <div class="getcode">
		        	<el-input v-model="form.code" placeholder="请输入验证码"></el-input>
		        	<el-button type="warning" class="code-btn" @click="getCode" :disabled="buttonDisable">{{buttonName}}</el-button>
		        </div>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="emailVisible = false">取 消</el-button>
		    <el-button size="mini" type="primary" @click="submitForm">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
import { getSelfInfo, updateUser,emailCode,emailBind } from '@/api/personal/index'
var index;
export default {
  data () {
	  var validateEmail = (rule, value, callback) => {
	  	  const regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	      if (!regEx.test(value)) {
	         callback(new Error('邮箱格式不正确，请重新输入!'));
	      } else {
	        callback()
	      }
	    } 
    return {
      data: {},
	  emailVisible:false,
	  form:{},
	  buttonName: '获取验证码',
	  buttonDisable: false,
	  timeNum: 59,
	  rules: {
	  	email:  [{ required:true, message: '请输入邮箱',trigger: 'blur'},
		{ validator: validateEmail,trigger: 'blur'}],
		code: [{ required:true, message: '请输入验证码',trigger: 'blur'}]
	  		
	  }
    }
  },
  methods: {
    async getInfo(){
    	const res = await getSelfInfo()
    	if (res.code === 0) {
    		this.data = res.data
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	async getCode(){
		this.buttonName = this.timeNum+'s后重新获取'
		this.buttonDisable = true;
		index = setInterval(()=>{ 
			this.timeNum--;		
			this.buttonName = this.timeNum+'s后重新获取';
			
		},1000)
		const res = await emailCode({email:this.form.email})
		if (res.code === 0) {
			this.$message.success('验证码发送成功')
		} else {
		  this.$message.error(res.msg)
		}
	},
	submitForm(){
		this.$refs.form.validate(async (valid) => {
		  if (valid) {
			const res = await emailBind({email:this.form.email,verfCode:this.form.code})
			if (res.code === 0) {
				this.emailVisible = false
				this.$message.success('邮箱绑定成功')
			} else {
			  this.$message.error(res.msg)
			}
		  } else {
			console.log('error submit!!');
			return false;
		  }
		});
	},
  },
  watch:{
	 timeNum(newval){
		 if(newval==0){
		 	this.buttonName = '获取验证码';
		 	this.buttonDisable = false;
		 	clearInterval(index);
			this.timeNum = 59;
		 }
	 } 
  },
  mounted () {
	this.getInfo()  
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
	}
	.tips{
		margin-top: 5px;
		color: #C1C1C2;
		font-size: 13px;
	}
	.change-email{
		margin-top: 20px;
		
		.labelname{
			color: #505050;
			font-size: 14px;
			margin: 5px 0;
		}
		.el-input{
			width: 300px;
		}
		.el-button--info{
			background-color: #F2F3F5;
			color: #313131;
			border: none;
			margin-left: 10px;
		}
		/deep/.el-input.is-active .el-input__inner, /deep/.el-input__inner:focus{
			border-color: #C0C4CC;
		}
	}
	.getcode{
		position: relative;
		.code-btn{
			position: absolute;
			bottom: 0;
			right: 0;
			background-color: #FF842E;
		}
	}
}	

</style>